
import React, { useRef } from "react";
import html2canvas from "html2canvas";
import "boxicons/css/boxicons.min.css";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import Lodderr from "../../components/Lodder/Lodder";


const BusinessCardModel = ({ show, handleClose, data }) => {

  const { loading } = useSelector((state) => state.TimelineSlice);
  console.log(data)
  const card1Ref = useRef();

  const handleDownload = async (ref, filename) => {
    const downloadBtn = ref.current.querySelector(".bc-download-btn");
    if (downloadBtn) downloadBtn.style.display = "none";
    await new Promise((resolve) => setTimeout(resolve, 300));
  
    const imgElement = ref.current.querySelector("img");
    if (imgElement && imgElement.src.includes("s3.amazonaws.com")) {
      const originalSrc = imgElement.src.split('?')[0];
      imgElement.src = `${originalSrc}?t=${Date.now()}`;
      await new Promise((resolve) => {
        imgElement.onload = resolve;
        imgElement.onerror = () => console.warn('Image load failed');
      });
    }
  
    const canvas = await html2canvas(ref.current, {
      useCORS: true,
      scale: 2,
      logging: true,
    });
  
    const link = document.createElement("a");
    link.download = filename;
    link.href = canvas.toDataURL("image/png");
    link.click();
  
    if (downloadBtn) downloadBtn.style.display = "block";
  };

  const member = data?.[0]; 

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Business Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-md-8 d-flex justify-content-center m-5">
                <div className="bc-business-card" ref={card1Ref}>
                  <button 
                    className="bc-download-btn"
                    onClick={() =>
                      handleDownload(card1Ref, `${member?.first_name || "card"}.png`)
                    }
                    title="Download Card"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                    </svg>
                  </button>

                  {/* Header with Company Info */}
                  <div className="bc-card-header">
                    <div className="bc-company-section">
                      <img 
                        src={`${member?.company_logo || "/default-logo.png"}?t=${Date.now()}`}
                        alt="Company Logo"
                        className="bc-company-logo"
                        crossOrigin="anonymous"
                      />
                      <div className="bc-company-details">
                        <h2 className="bc-company-name">{member?.company_name || "Company Name"}</h2>
                        <div className="bc-divider-line"></div>
                      </div>
                    </div>
                  </div>

                  {/* Main Content Area */}
                  <div className="bc-card-body">
                    <div className="bc-left-section">
                      <div className="bc-name-section">
                        <h1 className="bc-full-name">
                          {member?.salutation} {member?.first_name} {member?.last_name}
                        </h1>
                        <p className="bc-job-title">{member?.job_title}</p>
                      </div>
                    </div>

                    <div className="bc-right-section">
                      <div className="bc-contact-info">
                        <div className="bc-contact-group">
                          <div className="bc-contact-item">
                            <span className="bc-contact-label">Phone:</span>
                            <span className="bc-contact-value">+{member?.country_code} {member?.contact}</span>
                          </div>
                          
                          <div className="bc-contact-item">
                            <span className="bc-contact-label">Email:</span>
                            <span className="bc-contact-value">{member?.email}</span>
                          </div>
                          
                          <div className="bc-contact-item">
                            <span className="bc-contact-label">Web:</span>
                            <span className="bc-contact-value">{member?.company_website || "www.company.com"}</span>
                          </div>
                          
                          <div className="bc-contact-item">
                            <span className="bc-contact-label">Location:</span>
                            <span className="bc-contact-value">{member?.country}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer accent */}
                  <div className="bc-card-footer">
                    <div className="bc-footer-accent"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusinessCardModel;
